import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { Modal } from 'reactstrap';
import ShipMethodMappingForm from './ShipMethodMappingForm';

function ShipMethodMappingFormModal(props) {
  const {
    shown, t, mapping, onClose, onSuccess,
  } = props;
  const [modalOpen, setModalOpen] = useState(false);

  useEffect(() => {
    setModalOpen(shown);
  }, [mapping, shown]);

  const handleSuccess = (result) => {
    setModalOpen(false);
    onSuccess(result);
  };

  return (
    <Modal size="lg" isOpen={modalOpen}>
      <div className="modal-header">
        <h5 className="modal-title mt-0">
          {t('Save Ship Method Mapping')}
        </h5>
        <button
          onClick={() => { setModalOpen(false); onClose(); }}
          type="button"
          className="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div className="modal-body">
        <ShipMethodMappingForm entity={mapping} onSuccess={handleSuccess} />
      </div>
      <div className="modal-footer">
        <button
          type="button"
          onClick={() => { setModalOpen(false); onClose(); }}
          className="btn btn-soft-dark"
          data-dismiss="modal"
        >
          {t('Cancel')}
        </button>
        <button
          type="submit"
          form="ShipMethodMappingForm"
          className="btn btn-primary"
        >
          {t('Save')}
        </button>
      </div>
    </Modal>
  );
}

ShipMethodMappingFormModal.defaultProps = {
  t: (x) => x,
  shown: false,
  mapping: {},
  onClose: () => {},
  onSuccess: () => {},
};

ShipMethodMappingFormModal.propTypes = {
  t: PropTypes.any,
  shown: PropTypes.bool,
  mapping: PropTypes.object,
  onClose: PropTypes.func,
  onSuccess: PropTypes.func,
};

export default connect(() => ({}), {})(withTranslation()(ShipMethodMappingFormModal));
